import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { firebaseRef } from '../firebase.js';

class Inputcount extends Component {
  constructor(props){
    super(props);
    this.state = {
      click: false
    };
    this.count = this.count.bind(this);
  }

  componentWillMount(){
    var that=this;
    var user = this.props.match.params.user;
    var doctor = this.props.match.params.doctor;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/sri/'+this.props.title);
    refMain.on('child_added', (datasnapShot) =>{
      if (datasnapShot.val() === this.props.title) {
        that.setState({ click: true });
      }
    });
  }

  count(event){
    if (!this.state.click) {
    this.setState({ click: true });
    var user = this.props.match.params.user;
    var doctor = firebaseRef.auth().currentUser.uid;
    var refMain = firebaseRef.database().ref('doctors/'+doctor+'/users/'+user+'/sri/'+event.target.value);
    refMain.push(
      event.target.value
    );
  }else{
    this.setState({ click: false });
    refMain.remove();
  }
  }

  render() {
    const {title, group, main} = this.props;
    return (
        <div>
          <label htmlFor={group} className={`input-label-checkbox-normal ${this.state.click ? 'label-click': ''} ${main === 'sri' ? 'label-sri' : ''}`}>{title}</label>
          <input type="checkbox" name={group} value={group} className="user-inputs user-inputs-radio" id={group} onClick={this.count}/>
        </div>
    );
  }
}

export default withRouter(Inputcount);



// WEBPACK FOOTER //
// ./src/routes/Paitent/Inputcount.js